<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-07 17:31:59
 * @Description: 鲸鱼优选首页
 -->

<template>
  <div class="prefect-select-wrapper" ref="prefectSelect">
    <router-view class="main-wrapper"></router-view>
    <p v-if="footShow" class="tips-invest">市场有风险、出借需谨慎</p>
    <Mfooter v-if="footShow" />
  </div>
</template>
<script>
import Mfooter from '@/components/m-footer';
export default {
  name: 'prefect-select',
  components: {
    Mfooter
  },
  data() {
    return {
      footShow: true
    };
  },
  watch: {
    $route(e) {
      console.log(e.name);
      if (e.name === 'm-project-list') {
        this.footShow = true;
      } else {
        this.footShow = false;
      }
    }
  },
  mounted() {
    if (this.$route.name === 'm-project-list') {
      this.footShow = true;
    } else {
      this.footShow = false;
    }
  }
};
</script>
<style lang="less" scope>
.prefect-select-wrapper {
  width: 100%;
  // height: calc(100vh - 0.83rem);
  // overflow-y: auto;
}
.tips-invest {
  font-size: 0.2rem;
  text-align: center;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.7rem;
  letter-spacing: 0.06rem;
  color: #696969;
  margin: 0.2rem 0 0;
}
</style>
